import { Button as DialogButton, Field } from '@/ui'
import { Box, Button, Dialog, DialogContent, DialogTitle } from '@mui/material'
import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './EmployerDecline.module.scss'
import CloseButton from '@/components/CloseButton/CloseButton'
import { useDispatch, useSelector } from 'react-redux'
import { eColContractsSelectors, eColContractsThunks } from '@/entity'

export const TradeUnionDecline = ({ title, isEmployee, onClose, externalId, isOpen, handleCloseDecline }) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const isSuccessContract = useSelector(eColContractsSelectors.isSuccessContract)

	useEffect(() => {
		if (isSuccessContract) {
			onClose()
		}
	}, [isSuccessContract])

	const handleSign = () => {
		dispatch(eColContractsThunks.rejectTradeUnion(externalId, isEmployee))
	}

	return (
		<Dialog classes={{ paper: styles.dialog }} onClose={onClose} open={isOpen}>
			<Box>{onClose ? <CloseButton onClose={onClose}></CloseButton> : null}</Box>
			<DialogTitle classes={{ root: styles.sign__title }}>{t(title)}</DialogTitle>
			<DialogContent sx={{ paddingBottom: '40px' }}>
				<div className={styles.dialog__buttons__wrapper}>
					<div className={styles.reset__button__wrapper}>
						<DialogButton type="button" onClick={handleSign}>
							{t('decline')}
						</DialogButton>
					</div>
					<Button
						type="button"
						variant="text"
						classes={{ root: cn(styles.button, styles.reset__button, styles.reset__button) }}
						onClick={handleCloseDecline}
					>
						{t('cancel')}
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	)
}
